export const CONTEST_COURSE_TYPE_OPTIONS = [
  {
    label: 'Academy',
    value: 'academy',
  },
  {
    label: 'DSML',
    value: 'data_science',
  },
  {
    label: 'Neovarsity',
    value: 'neovarsity',
  },
  {
    label: 'Academy Without DSA',
    value: 'academy_without_dsa',
  },
] as const;
